// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__NxCGv","info":"Panel_info__2VXRx","btns":"Panel_btns__1j2qs","button":"Panel_button__2TmSi"};